import React from 'react';
import { BsFullscreen, BsFullscreenExit } from "react-icons/bs";

interface FocusTimerProps {
  formattedTime: string;
  isFullScreen: boolean;
  onToggleFullScreen: () => void;
}

const FocusTimer: React.FC<FocusTimerProps> = ({
  formattedTime,
  isFullScreen,
  onToggleFullScreen
}) => {
  return (
    <>
      <div className="counter">
        {formattedTime}
      </div>
      <div className="fullscreen-button" onClick={onToggleFullScreen}>
        {isFullScreen ? <BsFullscreenExit /> : <BsFullscreen />}
      </div>
    </>
  );
};

export default FocusTimer; 